/**
 * A typed error thrown by the stream processor when a handled stream failure occurs.
 * Carries the `ChatError` that was already set in the store via `failStream()`.
 * Callers can distinguish stream failures from unexpected bugs via `instanceof ChatStreamError`.
 */
export class ChatStreamError extends Error {
  constructor(chatError) {
    super(chatError.message);
    this.name = 'ChatStreamError';
    this.chatError = chatError;
  }
}